export default "__VITE_ASSET__3118eda1__"